
if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
        navigator.serviceWorker.register("/bitrix/js/sotbit.notification/sw-register.php", {scope: '/'});
    });
}